// ** React Import
import { Link } from 'react-router-dom'

// ** MUI Imports
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Custom Icon Import
import Icon from '../../../../components/icon'

// ** Hooks
import { useSettings } from 'components/hooks/useSettings'

// ** Styled Components
const MenuHeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: theme.spacing(2),
  transition: 'padding .25s ease-in-out',
  minHeight: theme.mixins.toolbar.minHeight,
  position: 'relative',
}))

const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  lineHeight: '24px',
  transition: 'opacity .25s ease-in-out, margin .25s ease-in-out'
})

const LinkStyled = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none'
})

const VerticalNavHeader = props => {
  // ** Props
  const {
    hidden,
    navHover,
    collapsedNavWidth,
    toggleNavVisibility,
    navigationBorderWidth,
    navMenuBranding: userNavMenuBranding
  } = props

  // ** Hooks
  const { settings } = useSettings()

  const menuHeaderPaddingLeft = () => {
    if (settings.navCollapsed && !navHover) {
      return (collapsedNavWidth - navigationBorderWidth - 42) / 8
    }
    return 5
  }

  return (
    <MenuHeaderWrapper
      className='nav-header'
      sx={{ pl: menuHeaderPaddingLeft(), py: 1, my: 1 }}
    >
      {userNavMenuBranding ? (
        userNavMenuBranding(props)
      ) : (
        <LinkStyled to='/dashboard'>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: settings.navCollapsed ? 'max-content' : '100px',
              margin: settings.navCollapsed
                ? '10px 10px 10px 0px !important'
                : '5px 10px',
              padding: settings.navCollapsed
                ? '20px 20px 20px 0px'
                : '10px 20px',
              gap: '10px',
              mt: 4,
              ...(settings.navCollapsed && !navHover ? {} : { ml: 2.5 })
            }}
          >
            <img
              height='50'
              alt='company-logo'
              src={
                settings.navCollapsed && !navHover
                  ? settings.mode === 'dark'
                    ? '/images/Logo1.svg'
                    : '/images/Logo1.svg'
                  : settings.mode === 'dark'
                    ? '/images/Logo2_Light.svg'
                    : '/images/Logo2.svg'
              }
            />
          </Box>
        </LinkStyled>
      )}
      {hidden && (
        <IconButton
          disableRipple
          disableFocusRipple
          onClick={toggleNavVisibility}
          sx={{
            p: 0,
            color: 'text.secondary',
            backgroundColor: 'transparent !important'
          }}
        >
          <Icon icon='tabler:x' fontSize='1.25rem' />
        </IconButton>
      )}
    </MenuHeaderWrapper>
  )
}

export default VerticalNavHeader
